import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Segment } from 'src/app/core/models/itinerary.model';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import { SettingsService } from 'src/app/settings/services/settings.service';

@Component({
  selector: 'app-ticket-segment',
  templateUrl: './ticket-segment.component.html',
  styleUrls: ['./ticket-segment.component.scss']
})
export class TicketSegmentComponent implements OnInit {
  @Input() ticketSegments: Segment[];
  @Input() name: string;
  isMultidestiny = true;
  isAirline$: Observable<boolean>;
  numberFlightValidatingCarrier;

  constructor(private itService: ItineraryService, private settingsService: SettingsService) { }
  ngOnInit() {
    this.isAirline$ = this.settingsService.getClientIsAirline();
    this.isMultidestiny = this.isMultidestinyTrip();
    this.itService
      .getPnrInfo()
      .pipe(take(1))
      .subscribe((pnr) => {
        if (pnr) {
          this.numberFlightValidatingCarrier = this.ticketSegments;
        }
      });
  }

  isMultidestinyTrip(): boolean {
    return !!this.ticketSegments && this.ticketSegments.length === 2 && this.isRoundTrip()
      ? false
      : true;
  }

  isRoundTrip(): boolean {
    return (
      this.ticketSegments[0].departureLocation.code === this.ticketSegments[1].arrivalLocation.code
    );
  }
}
